export const RESULTS_PAGE_ID = 'results';

export const ResultsPaneTitle = 'Results';

export const ResultsPaneEvents = Object.freeze({
    OPEN_COMPOUND: 'resultsPaneOpenCompound',
    CLOSE: 'resultsPaneClose',
});
